import type { StripeShopProduct, StripeShopPrice } from "./stripeShopTypes";
import type { SelectedShopVariant } from "./types";

export const buildSelectedShopVariant = (price: StripeShopPrice): SelectedShopVariant => ({
  stripePriceId: price.id,
  amount: price.unit_amount ?? 0,
  currency: price.currency,
  isSubscription: price.type === "recurring",
  interval: price.recurring?.interval,
  intervalCount: price.recurring?.interval_count,
});

export const buildSelectedShopProductFields = (product: StripeShopProduct) => ({
  stripeProductId: product.id,
  title: product.name,
  description: product.description ?? undefined,
  image: product.images[0],
});
